import { HttpClient, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { LesLibrairesStatus } from "./les-libraires-status";

@Injectable()
export class LesLibrairesService {
  constructor(private httpClient: HttpClient) { }

  public getStatus(): Observable<LesLibrairesStatus> {
    return this.httpClient.get<LesLibrairesStatus>(`/api/les-libraires`);
  }

  public exportInventory(): Observable<HttpResponse<void>> {
    return this.httpClient.post<HttpResponse<void>>(`/api/les-libraires`, {});
  }
}